import { Pipe, PipeTransform } from '@angular/core';
import { StaticData } from '../helpers/static-data';

@Pipe({
  name: 'bestdocFilter'
})
export class BestdocFilterPipe implements PipeTransform {
  transform(value: string, replaceWith: string = ''): string {
    if (!value) return value;
    
    // Si LogosBestDoc es false, reemplaza "BestDoc" con el texto alternativo
    if (!StaticData.LogosBestDoc) {
      return value.replace(/BestDoc/gi, replaceWith);
    }
    
    return value;
  }
}
